import { render, staticRenderFns } from "./ExaminationVL.vue?vue&type=template&id=18a7446a&"
import script from "./ExaminationVL.vue?vue&type=script&lang=js&"
export * from "./ExaminationVL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports